module.exports = __webpack_public_path__ + "static/media/call_icon.35901700.svg";